import styled from 'styled-components';

const TileHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25em 0.625em;
  min-height: 3.75em;
`;

export default TileHeader;
